import React, { useEffect, useRef } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { BrandLogo } from '@examflow/ui';
import { useAuth } from '../features/auth/AuthContext';

/**
 * Thin route: no local signup form. Casdoor owns account creation (web app SignUp).
 */
const RegisterPage: React.FC = () => {
  const { signIn, isAuthenticated, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') || '/workspace';
  const startedRef = useRef(false);

  useEffect(() => {
    if (loading || isAuthenticated || startedRef.current) return;
    startedRef.current = true;
    signIn(redirect, 'signUp');
  }, [loading, isAuthenticated, redirect, signIn]);

  if (!loading && isAuthenticated) {
    return <Navigate to={redirect.startsWith('/') ? redirect : `/${redirect}`} replace />;
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 px-4">
      <BrandLogo variant="mark" size={40} />
      <p className="text-sm text-slate-500">正在前往注册…</p>
    </div>
  );
};

export default RegisterPage;
